import React from 'react';

import './styles.scss';

/* eslint-disable */
export default props => (
  <div className={`loader ${props.isActive && 'active'}`}>
    <div className="loader__wrapper">
      <div className="loader__container">
        <div className="loader__corner--top" />
        <div className="loader__corner--bottom" />
      </div>
      <div className="loader__square" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Loader/index.js